(ns ui.card
  (:require
   ["react" :as react]
   [applied-science.js-interop :as jsi]
   [clojure.set :as c.set]
   [reagent.core :as reagent]
   [ui.typography :as typography]
   [ui.utils :refer [clsx separate-props]]))

(defn card-overlay []
  [:div {:class "absolute inset-0 z-1 pointer-events-none bg-kleene-neutral-01 opacity-0 dark:opacity-25 dark:group-hover:opacity-0 group-hover:opacity-25 transition-opacity"}])

(defn card-content [& args]
  (let [[props children] (separate-props args)]
    (into [:div (-> props
                    (update :class #(clsx "p-4" %)))]
          children)))

(defn card-header [& args]
  (let [[props children] (separate-props args)]
    (into [:div (-> props
                    (update :class #(clsx "p-2" %)))]
          children)))

(defn card-title [& args]
  (let [[props children] (separate-props args)]
    (into [typography/h3 props]
          children)))

(defn card-description [& args]
  (let [[props children] (separate-props args)]
    (into [typography/p (-> props
                            (update :class #(clsx "text-sm text-kleene-text-secondary" %)))]
          children)))

(defn card-footer [& args]
  (let [[props children] (separate-props args)]
    (into [typography/p (-> props
                            (update :class #(clsx "flex items-center justify-end border-t bg-kleene-background-secondary p-2" %)))]
          children)))

(defn card [& args]
  (let [[props children] (separate-props args)
        clickable (or (:on-click props)
                      (:clickable props)
                      (= :a (:tag props)))
        tag (cond
              (:tag props) (:tag props)
              clickable    :button
              :else        :div)]
    (into [tag (-> props
                   (dissoc :tag :overlay-props :clickable)
                   (update :class #(clsx "relative border rounded-sm bg-kleene-background"
                                         {"group cursor-pointer w-full" clickable}
                                         %)))
           (when clickable [card-overlay])]
          children)))

(def card-fr
  (react/forwardRef
   (fn [props ref]
     (reagent/as-element [card
                          (-> (js->clj props :keywordize-keys true)
                              (assoc :ref ref)
                              (dissoc :children)
                              (c.set/rename-keys {:overlayProps :overlay-props
                                                  :className    :class}))
                          (jsi/get props :children)]))))
